import axios from 'axios'
import store from '@/store'
import router from '@/router'

// All axios requests and responses are intercepted here.

export default function setup () {
  // Before each request
  axios.interceptors.request.use(function (config) {
    if (store.state.auth.token) {
      config.headers.Authorization = 'Token ' + store.state.auth.token
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })

  // After each response
  axios.interceptors.response.use(undefined, function (error) {
    return new Promise(function (resolve, reject) {
      if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
        // 401 Unauthorized - remove token and redirect to login
        store.commit('removeToken')
        router.push({name: 'Login', params: {message: 'logout'}})
      }
      throw error
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/interceptors.js